import React from 'react';
import LiteratureThumbHtmlView from './LiteratureHtml';
import LiteratureThumbReactView from './Literature';
const LiterartureThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(LiteratureThumbHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(LiteratureThumbReactView, props);
};
LiterartureThumbView.displayName = 'LiterartureThumbView';
export default LiterartureThumbView;

//# sourceMappingURL=index.js.map